import Vue from 'vue';
import Vuex from 'vuex';

import {
  state,
  getters,
  actions,
  mutations,
} from './root';

// modules
import user from './modules/user';
import video from './modules/video';
import search from './modules/search';
import advertiser from './modules/advertiser';
import category from './modules/category';
import dashboard from './modules/dashboard';

import count from './modules/count';
import todos from './modules/todos';
import list from './modules/list';

Vue.use(Vuex);

/**
  * 這命名是固定的：
  * state, mutations, getters, actions
 */
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  modules: {
    user,
    search,
    advertiser,
    category,
    video,
    dashboard,
    
    count,
    todos,
    list,
  },

  strict: true,
});



// WEBPACK FOOTER //
// ./src/store/index.js